import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=521b8d8c&"
import script from "./filter-item.vue?vue&type=script&setup=true&lang=ts&"
export * from "./filter-item.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports